import { Lesson } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useListVals } from 'react-firebase-hooks/database';
import { withDefaultList } from './defaults';

export const useLessonsList = () => {
	const database = useDatabase();
	const [lessons, loading, error] = useListVals<Lesson, 'id'>(ref(database, 'lessons'), { keyField: 'id' });
	return [withDefaultList(lessons), loading, error] as const;
}

// export const useLessonsList = () => {
// 	const database = useDatabase();
// 	const [slots, loading, error] = useListVals<Slot, 'id'>(ref(database, 'slots'), { keyField: 'id' });
// 	const lessons = slots.flatMap(slot => slot.lessons ?? []);
// 	return [withDefaultList(lessons), loading, error] as const;
// }
